/**
 * Client-side wishlist (localStorage-backed, no app dependency). Handles:
 * - toggling the heart icon on product cards and the product page
 * - keeping every [data-wishlist-count] bubble in sync (header + bottom nav)
 * - rendering /pages/wishlist from stored product snapshots
 * For a Wishlist Plus / Swym integration instead, replace WISHLIST.toggle()
 * with the app's API call and keep the same event wiring.
 */
(function () {
  'use strict';
  var KEY = 'wallz:wishlist';

  function getAll() { return WallZ.utils.getStorage(KEY, []); }
  function isSaved(id) { return getAll().some(function (p) { return String(p.id) === String(id); }); }

  function toggle(product) {
    var list = getAll();
    var exists = list.some(function (p) { return String(p.id) === String(product.id); });
    if (exists) {
      list = list.filter(function (p) { return String(p.id) !== String(product.id); });
    } else {
      list.unshift(product);
    }
    WallZ.utils.setStorage(KEY, list);
    updateButtons();
    updateCount();
    return !exists;
  }

  function updateCount() {
    var count = getAll().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.dataset.productId;
      btn.classList.toggle('is-active', isSaved(id));
    });
  }

  function extractProductFromCard(card) {
    var id = card.querySelector('[data-wishlist-toggle]').dataset.productId;
    var titleEl = card.querySelector('.product-card__title, .product-info__title');
    var link = card.querySelector('a[href]');
    var img = card.querySelector('img');
    var priceEl = card.querySelector('.product-card__price-sale, .product-info__price [data-sale-price], .product-card__price span');
    return {
      id: id,
      title: titleEl ? titleEl.textContent.trim() : '',
      url: link ? link.getAttribute('href') : '#',
      image: img ? img.getAttribute('src') : '',
      price: priceEl ? priceEl.textContent.trim() : '',
    };
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    var items = getAll();
    if (!items.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = items.map(function (p) {
      return '<div class="product-card" data-wishlist-page-item data-product-id="' + p.id + '">' +
        '<div class="product-card__media"><a href="' + p.url + '" class="product-card__media-link"><img class="product-card__img product-card__img--primary" src="' + p.image + '" loading="lazy" alt="' + (p.title || '') + '"></a>' +
        '<button type="button" class="product-card__wishlist is-active" data-wishlist-toggle data-product-id="' + p.id + '" aria-label="Remove from wishlist"><svg class="icon" width="17" height="17" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M12 20.5s-7.5-4.6-10-9.3C0.3 7.8 2 4.5 5.3 4A5 5 0 0 1 12 6.5 5 5 0 0 1 18.7 4c3.3 0.5 5 3.8 3.3 7.2C19.5 15.9 12 20.5 12 20.5z"/></svg></button></div>' +
        '<div class="product-card__info"><h3 class="product-card__title"><a href="' + p.url + '">' + (p.title || '') + '</a></h3><div class="product-card__price">' + (p.price || '') + '</div></div></div>';
    }).join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    updateCount();
    renderWishlistPage();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-product-card], .product-page, [data-wishlist-page-item]');
      var product;
      if (card) {
        product = extractProductFromCard(card);
      } else {
        product = { id: btn.dataset.productId, title: document.title, url: window.location.pathname, image: '', price: '' };
      }
      var nowSaved = toggle(product);
      btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
      if (document.querySelector('[data-wishlist-grid]')) renderWishlistPage();
    });
  });
})();
